import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CustomModal from "../base/CustomModal"
import i18n from "../../I18n";
import { isPadOrMobile } from "utils/ScreenUtils";
import "./LevelBenefit.scss";
import { createAction, getTranslationField } from "utils";
import LoadMoreSpinner from "component/common/LoadMoreSpinner";
import LevelBenefitSection from "./LevelBenefitSection";

const LevelBenefit = ({
  language,
  levelBenefits,
  levelBenefitsLoading,
  level,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [activeKey, setActiveKey] = useState(level);

  useEffect(() => {
    dispatch(createAction("levels/fetchLevelBenefits")());
  }, [])

  useEffect(() => {
    if (level) {
      setActiveKey(level);
    } else {
      setActiveKey(levelBenefits?.[0]?.levelId);
    }
  }, [level, levelBenefits]);

  const handleClick = () => {
    if (isPadOrMobile()) {
      history.push("/level_benefit")
    } else {
      setShowModal(true)
    }
  }

  const tabs = useMemo(() => {
    if (levelBenefitsLoading) {
      return [
        {
          key: null,
          name: null,
          content: (
            <div className="level-benefit-modal-loading">
              <LoadMoreSpinner />
            </div>
          )
        }
      ]
    }

    return levelBenefits.map(singleLevel => ({
      key: singleLevel.levelId,
      name: getTranslationField(singleLevel, "levelName", language),
      content: <LevelBenefitSection benefits={singleLevel.levelBenefits} language={language} />
    }))
  }, [levelBenefitsLoading, levelBenefits, language]);

  return (
    <>
      <div className="home-level-benefit-section d-flex" onClick={handleClick}>
        <div className="common-profile-section-text field-text">
          <img
            alt="icon"
            src={"/profile/levelBenefit/gift.png"}
            srcSet={"/profile/levelBenefit/gift@2x.png 2x, /profile/levelBenefit/gift@3x.png 3x"}
          />
          {i18n.t("level_benefit")}
        </div>
        <div className="arrow-icon">
          <img alt="icon" src={"/profile/right-arrow.png"} />
        </div>
      </div>
      <CustomModal
        title={i18n.t("level_benefit")}
        show={showModal}
        hideTab={levelBenefitsLoading}
        tabs={tabs}
        activeTab={activeKey}
        onClose={() => { setShowModal(false) }}
        onTabChange={(key) => { setActiveKey(key) }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  levelBenefits: state.levels.levelBenefits,
  levelBenefitsLoading: state.levels.levelBenefitsLoading,
  level: state.users.level,
})

export default connect(mapStateToProps)(LevelBenefit);
